interface ContactUpgradeBody {
  message?: string
}

interface ContactUpgradeResponse {
  status: string
}

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...init,
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }))
    throw new Error((err as { detail?: string }).detail ?? res.statusText)
  }
  if (res.status === 204) return undefined as T
  return res.json()
}

export const contactService = {
  requestUpgrade: async (body: ContactUpgradeBody = {}): Promise<ContactUpgradeResponse> => {
    return request<ContactUpgradeResponse>('/api/v1/contact/upgrade', {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },
}
